import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=c18ec53e&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"
import style0 from "./RootView.vue?vue&type=style&index=0&id=c18ec53e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18ec53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c18ec53e')) {
      api.createRecord('c18ec53e', component.options)
    } else {
      api.reload('c18ec53e', component.options)
    }
    module.hot.accept("./RootView.vue?vue&type=template&id=c18ec53e&scoped=true", function () {
      api.rerender('c18ec53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/RootView.vue"
export default component.exports